export default {
  heroSlide1Title: "Accélérer les soins de santé du laboratoire à la vie",
  // heroSlide1Subtitle: "Innovation pharmaceutique de premier plan avec plus de 40 ans d'expertise en API psychotropes et génériques complexes",
  heroSlide2Title: "Portée mondiale – Clients dans plus de 80 pays",
  // heroSlide2Subtitle: "Établir des relations solides avec les principaux innovateurs pharmaceutiques et les entreprises de génériques dans le monde entier",
  heroSlide3Title: "Des blocs de construction aux formulations : Un partenaire. Fiabilité totale",
  // heroSlide3Subtitle: "Solutions pharmaceutiques de bout en bout avec chaîne de valeur intégrée couvrant KSM, API et FDF",
  heroSlide4Title: "6 installations mondiales | 4 centres R&D | 1 plateforme pharmaceutique mondiale",
  // heroSlide4Subtitle: "Infrastructure de fabrication et de recherche de classe mondiale favorisant l'innovation et l'excellence de la qualité",
  heroSlide5Title: "Nos sociétés du groupe",
  // heroSlide5Subtitle: "Un portefeuille diversifié de sociétés travaillant ensemble pour fournir des solutions pharmaceutiques complètes",
};

